import React from "react";
import { LOGO_URL } from "../lib/memeData";

/**
 * Static logo render. (No spin overlay — original artwork's propeller is kept as-is.)
 * `withSpinner` kept as a no-op prop for backwards compat.
 */
export const Logo = ({ size = 220, withSpinner = false, className = "" }) => {
  return (
    <div
      className={`relative inline-block ${className}`}
      style={{ width: `min(${size}px, 80vw)`, aspectRatio: "1 / 1", maxWidth: "100%" }}
      data-testid="retard-logo"
    >
      <img
        src={LOGO_URL}
        alt="$RETARD coin logo"
        className="w-full h-full object-contain select-none"
        draggable={false}
      />
    </div>
  );
};

export default Logo;
